import React, { useMemo, useState, useEffect } from "react"
import { Row, Container, CardBody, Card, Modal, ModalBody } from "reactstrap"
import Breadcrumb from "components/Common/Breadcrumb"
import { Link, useNavigate } from "react-router-dom"

import { app_url } from "app_config"
import { deleteNow } from "helpers/delete_function"

import { axiosbaseurl } from "configure"
import Loader from "components/Common/Loader"
import moment from "moment"
import { setUpdatedData } from "helpers/data_setters"
import { usePermissionData } from "AppContext"
import * as XLSX from "xlsx"
import swal from "sweetalert"
import ClientEmailTemplates from "./EmailTemplates"
import ClientEmailFilesModal from "./ClientEmailFilesModal"
import PermittedComponent from "components/Common/PermittedComponent"
import { Popover } from "antd"
import ClientFilter from "./ClientFilter"
import CommonTable from "components/Common/CommonTable"
import { designation_options } from "constants/layout"

const AllClients = () => {
  const [show, setShow] = useState(false)
  // const [clientFile, setClientFile] = useState(null)

  const [table_data, settable_data] = useState([])
  const [all_client_data, setall_client_data] = useState([])
  const [documents, setDocuments] = useState(null)
  const [mailCount, setMailCount] = useState(0)
  const [clientEmailCounts, setClientEmailCounts] = useState({})
  const [loading, setLoading] = useState(false)
  const [loading2, setLoading2] = useState(false)
  const [designations, setdesignations] = useState([])
  const [selectForExport, setSelectForExport] = useState([])
  const [emp_options, setemp_options] = useState([])
  const [practice_options, setpractice_options] = useState([])
  const [status_options, setstatus_options] = useState([])

  const [showEmails, setShowEmails] = useState(false)
  const [clientData, setClientData] = useState({})
  const [showEmailFiles, setShowEmailFiles] = useState(false)
  const [emailFilesClient, setEmailFilesClient] = useState({})
  const [searchValue, setSearchValue] = useState("")
  const [visible, setVisible] = useState(false)

  const { checkAccess, permissions } = usePermissionData()
  const module_id = 1

  const navigate = useNavigate()

  document.title = "Clients | Peacock Accountants Limited"

  useEffect(() => {
    const getClients = async () => {
      try {
        setLoading(true)
        const [response, response2] = await Promise.all([
          axiosbaseurl.get("/client"),
          axiosbaseurl.get("/client-email"),
        ])
        if (response.data.success) {
          const getFullName = (client, field) =>
            `${client[field]?.name || ""} ${
              client[field]?.middleName ? client[field]?.middleName + " " : ""
            }${client[field]?.lastName || ""}`.trim()

          const tempData = response.data.data.map(item => ({
            ...item,
            clientType: item?.clientType?.clientType || "--",
            administratorName: getFullName(item, "administrator"),
            assistantName: getFullName(item, "assistant"),
            clientManagerName: getFullName(item, "clientManager"),
            productionManagerName: getFullName(item, "productionManager"),
            CISManagerName: getFullName(item, "CISManager"),
            payrollManagerName: getFullName(item, "payrollManager"),
            clientStatusName: item.clientStatus?.statusName || "",
          }))
          // .sort((a,b) => (a.clientCode - b.clientCode))

          settable_data(tempData)
          setall_client_data(tempData)

          // setting options
          setemp_options(setCustomOptions(response.data.data, "employee"))
          setpractice_options(setCustomOptions(response.data.data, "practice"))
          setstatus_options(setCustomOptions(response.data.data, "status"))

          if (response.data.isAdmin)
            setdesignations(designation_options.map(des => des.value))
          else if (response.data.employeeDesignation)
            setdesignations(JSON.parse(response.data.employeeDesignation))
        }
        if (response2.data.success) {
          const emails = response2.data.data || []
          setMailCount(emails.length)
          const counts = {}
          emails.forEach(email => {
            if (email.clientId)
              counts[email.clientId] = (counts[email.clientId] || 0) + 1
          })
          setClientEmailCounts(counts)
        }
      } catch (error) {
        console.log(error)
      } finally {
        setLoading(false)
      }
    }
    getClients()
  }, [])

  // creating options for employees & practice
  function setCustomOptions(clients = [], type) {
    const options = []

    switch (type) {
      case "employee":
        const assistants = [
          "assistant",
          "assistantTwo",
          "assistantThree",
          "assistantFour",
        ]
        const empTypes = [
          ...assistants,
          "clientManager",
          "productionManager",
          "assistant",
          "administrator",
        ]

        clients.forEach(curr => {
          assistants.forEach(empType => {
            if (
              !options.some(i => i?.id === curr[empType]?.id) &&
              curr[empType]
            ) {
              options.push({ ...curr[empType], isAssistant: true })
            }
          })
        })

        clients.forEach(curr => {
          empTypes.forEach(empType => {
            if (
              !options.some(i => i?.id === curr[empType]?.id) &&
              curr[empType]
            ) {
              options.push({ ...curr[empType] })
            }
          })
        })

        break

      case "practice":
        clients.forEach(curr => {
          if (
            curr.clientUnderPractice &&
            !options.some(i => i.id === curr?.clientUnderPractice?.id)
          )
            options.push(curr.clientUnderPractice)
        })
        break

      case "status":
        clients.forEach(curr => {
          if (
            curr.clientStatus &&
            !options.some(i => i.id === curr?.clientStatus?.id)
          )
            options.push(curr.clientStatus)
        })
        break

      default:
        options = []
    }

    return options
  }

  // search client Details - implemented debouncing
  useEffect(() => {
    const handler = setTimeout(searchClients, 1000)

    return () => {
      clearTimeout(handler)
    }
  }, [searchValue])

  // Search clients functionality
  const searchClients = () => {
    const excludedFields = [
      "CISManager",
      "assistant",
      "clientManager",
      "clientStatus",
      "clientUnderPractice",
      "connectionId",
      "paymentMethod",
      "payrollManager",
      "productionManager",
      "serviceNameId",
    ]

    if (searchValue) {
      const filteredData = all_client_data?.filter(client => {
        return Object.keys(client)
          .filter(key => client[key] && !excludedFields.includes(key))
          .some(item =>
            String(client[item])
              ?.toLowerCase()
              ?.includes(searchValue.toLowerCase())
          )
      })

      settable_data(filteredData)
    } else {
      if (all_client_data.length) settable_data(all_client_data)
    }
  }

  // const getDocuments = async (client_id, clientName) => {
  //   try {
  //     const response = await axiosbaseurl.get(
  //       `/client-document/client/${client_id}`
  //     )
  //     if (response.data.success) {
  //       setDocuments({
  //         clientName,
  //         data: response.data.data || [],
  //       })
  //       setShow(true)
  //     }
  //   } catch (error) {
  //     console.log(error)
  //     swal(
  //       "",
  //       error.response.data.message || "Error Fetching Documents",
  //       "error"
  //     )
  //   }
  // }

  // delete client

  const handleDelete = async id => {
    try {
      const response = await axiosbaseurl.delete(`/client/${id}`)
      if (response.data.success)
        settable_data(prev =>
          setUpdatedData(prev, response.data.data, "delete")
        )
    } catch (error) {
      console.log(error)
      swal("", error.response.data.message || "Something went Wrong", "error")
    }
  }

  // update company house details individually
  const handleUpdateDetails = async id => {
    try {
      setLoading2(id)
      const { data } = await axiosbaseurl.put(`/client/company/house/${id}`)
      if (data.success)
        swal("", "Company House Details Updated Successfully", "success")
    } catch (error) {
      console.log(error)
      swal("", error.response.data.message || "Something went Wrong", "error")
    } finally {
      setLoading2(false)
    }
  }

  // designation wise email & export client access
  const isEmailExportAllowed =
    designations?.includes("Client Manager") ||
    designations?.includes("Production Manager") ||
    designations?.includes("Administrator")

  // Table Columns
  const columns = useMemo(
    () => [
      ...(isEmailExportAllowed
        ? [
            {
              Header: "",
              accessor: "checkbox",
              disableSort: true,
              Cell: cellProps => (
                <input
                  type="checkbox"
                  onChange={e => {
                    if (e.target.checked)
                      setSelectForExport(prev => [
                        ...prev,
                        cellProps.row.original.id,
                      ])
                    else
                      setSelectForExport(prev =>
                        prev.filter(s => s !== cellProps.row.original.id)
                      )
                  }}
                  checked={selectForExport.some(
                    s => s === cellProps.row.original.id
                  )}
                />
              ),
            },
          ]
        : []),
      {
        Header: "ID",
        accessor: "id",
        filterable: true,
        disableFilters: true,
        className: "text-center",
        Cell: cellProps => <span>{cellProps.row.index + 1}</span>,
      },
      {
        Header: "Client Code",
        accessor: "clientCode",
        disableFilters: true,
        className: "text-center",
        filterable: true,
        Cell: cellProps => (
          <Link
            to={`${app_url}edit-client/${cellProps.row.original.id}`}
            style={{
              color: cellProps.row.original.hasPractice ? "#40a676" : "#dd4949",
            }}
            className="fw-bold"
            title={`Practice details is ${
              cellProps.row.original.hasPractice ? "" : "not "
            }available`}
          >
            {cellProps.row.original.clientCode}
          </Link>
        ),
      },
      {
        Header: "Client Name",
        accessor: "clientName",
        disableFilters: true,
        filterable: true,
        className: " col-2",
      },
      {
        Header: "Client Type",
        accessor: "clientType",
        disableFilters: true,
        filterable: true,
      },

      {
        Header: "CH No.",
        accessor: "companyHouseNumber",
        disableFilters: true,
        filterable: true,
        className: " text-center",
        Cell: cellProps => (
          <span>{cellProps.row.original.companyHouseNumber || "N/A"}</span>
        ),
      },
      {
        Header: "UTR No.",
        accessor: "UTRNumber",
        disableFilters: true,
        filterable: true,
        className: " text-center",
        Cell: cellProps => (
          <span>{cellProps.row.original.UTRNumber || "N/A"}</span>
        ),
      },
      {
        Header: "VAT No.",
        accessor: "VATNumber",
        disableFilters: true,
        filterable: true,
        className: "text-center",
        Cell: cellProps => (
          <span>{cellProps.row.original.VATNumber || "N/A"}</span>
        ),
      },
      {
        Header: "Assistant",
        accessor: "assistantName",
        disableFilters: true,
        filterable: true,
        className: " text-center",
        Cell: cellProps => (
          <span>{cellProps.row.original.assistantName || "N/A"}</span>
        ),
      },
      {
        Header: "Emails",
        accessor: "emailCount",
        disableFilters: true,
        className: "text-center",
        Cell: cellProps => {
          const count = clientEmailCounts[cellProps.row.original.id] || 0
          return (
            <span
              className={`badge ${count ? "bg-primary" : "bg-secondary"}`}
              style={{ fontSize: "0.8rem" }}
            >
              {count}
            </span>
          )
        },
      },
      {
        Header: "Action",
        disableFilters: true,
        disableSort: true,
        accessor: "view",
        className: " text-center",
        Cell: cellProps => {
          const { id, clientName } = cellProps.row.original

          return (
            <div>
              {(checkAccess(module_id, "view") ||
                checkAccess(module_id, "edit")) && (
                <Link
                  to={`${app_url}edit-client/${id}`}
                  className="btn btn-success bg-green btn-sm me-2"
                >
                  <i
                    className={`fas fa-${
                      checkAccess(module_id, "edit") ? "pen" : "eye"
                    }`}
                  ></i>
                </Link>
              )}

              {isEmailExportAllowed && (
                <button
                  onClick={() => {
                    setShowEmails(true)
                    setClientData(cellProps.row.original)
                  }}
                  title="Email Templates"
                  className="btn btn-primary btn-sm me-2"
                >
                  <i className="fas fa-envelope"></i>
                </button>
              )}
              <button
                onClick={() => {
                  setEmailFilesClient(cellProps.row.original)
                  setShowEmailFiles(true)
                }}
                title="Email Files (.msg / .eml)"
                className="btn btn-info btn-sm me-2"
              >
                <i className="fas fa-paperclip"></i>
              </button>

              {/* <button
                onClick={() => {
                  // getDocuments(id, clientName)
                  swal(
                    "Work In Progress !",
                    "This feature is in development phase.",
                    "warning"
                  )
                }}
                className="btn btn-secondary btn-sm me-2"
                title="Clients Documents"
              >
                <i className="fas fa-book"></i>
              </button> */}

              {checkAccess(module_id, "remove") && (
                <button
                  onClick={() => deleteNow(() => handleDelete(id))}
                  className="btn btn-danger btn-sm ml-10"
                >
                  <i className="fas fa-trash-alt"></i>
                </button>
              )}

              {checkAccess(module_id, "edit") && (
                <button
                  onClick={() => handleUpdateDetails(id)}
                  title="Update Company House Details"
                  className="btn btn-warning btn-sm ms-2 "
                  disabled={loading2}
                >
                  <i
                    className={`${
                      id == loading2
                        ? "bx bx-loader bx-spin"
                        : "fa fa-calendar-check"
                    }`}
                  ></i>
                </button>
              )}
            </div>
          )
        },
      },
    ],
    [
      permissions,
      isEmailExportAllowed,
      loading2,
      selectForExport,
      clientEmailCounts,
    ]
  )

  // setting table data
  const data = useMemo(() => table_data, [table_data])

  function formatDate(date) {
    return date ? moment.utc(date).format("DD-MM-YYYY") : "--"
  }

  function getServices(data) {
    if (data) {
      const service = JSON.parse(JSON.parse(data))
      return service?.map(i => i.name)?.toString()
    }
    return "--"
  }

  const handleExportToExcel = () => {
    // Prepare the data for Excel

    function getExportingData(datas) {
      return datas.map(i => ({
        ["Client Id"]: i.id,
        ["Client Type*"]: i.clientType || "--",
        ["Client Code*"]: i.clientCode || "--",
        ["Client Name*"]: i.clientName || "--",
        ["Trading Name*"]: i.tradingName || "--",
        ["Email*"]: i.email || "--",
        ["Company House Number"]: i.companyHouseNumber || "--",
        ["Registered Address"]: i.registeredAddress || "--",
        ["Correspondence Address"]: i.correspondenceAddress || "--",
        ["Business Nature"]: i.businessNature || "--",
        ["Website Link"]: i.websiteLink || "--",
        ["Client Status*"]: i.clientStatus?.statusName || "--",
        ["Company House Status"]: i.trading || "--",

        ["Bookkeeper Involved?"]: i.haveBookeeper || "--",
        ["Bookkeeper*"]: i.bookkeeper?.preferredName || "--",
        ["Bookkeeping System*"]: i.bookkeepingSystem?.bookkeepingSystem || "--",

        ["Primary Prefix*"]: i.primaryPrefixData?.prefixName || "--",
        ["Primary Forename*"]: i.primaryForename || "--",
        ["Primary Surname*"]: i.primarySurname || "--",
        ["Primary Preferred Name*"]: i.primaryPreferredName || "--",
        ["Primary Email"]: i.primaryEmail || "--",
        ["Primary DOB*"]: formatDate(i.primaryDOB) || "--",
        ["Primary Occupation*"]: i.primaryOccupation || "--",
        ["Primary Contact 1*"]: i.primaryMobile || "--",
        ["Primary Contact 2"]: i.primaryLandline || "--",
        ["Primary AddressLine1*"]: i.primaryAddressLine1 || "--",
        ["Primary AddressLine2"]: i.primaryAddressLine2 || "--",
        ["Primary Country*"]: i.primaryCountry || "--",
        ["Primary City*"]: i.primaryCity || "--",
        ["Primary Postcode*"]: i.primaryPostcode || "--",
        ["Primary Contact Description"]: i.primaryContactDescription || "--",

        ["Use Secondary if Primary Absence?"]: i.haveSecondaryContact || "--",

        ["Secondary same as Primary?"]: i.sameAsPrimaryDetails || "--",

        ["Secondary Prefix*"]: i.secondaryPrefixData?.prefixName || "--",
        ["Secondary Forename*"]: i.secondaryForename || "--",
        ["Secondary Surname*"]: i.secondarySurname || "--",
        ["Secondary Preferred Name*"]: i.secondaryPreferredName || "--",
        ["Secondary Email"]: i.secondaryEmail || "--",
        ["Secondary DOB*"]: formatDate(i.secondaryDOB) || "--",
        ["Secondary Occupation*"]: i.secondaryOccupation || "--",
        ["Secondary Contact 1*"]: i.secondaryMobile || "--",
        ["Secondary Contact 2"]: i.secondaryLandline || "--",
        ["Secondary AddressLine1*"]: i.secondaryAddressLine1 || "--",
        ["Secondary AddressLine2"]: i.secondaryAddressLine2 || "--",
        ["Secondary Country*"]: i.secondaryCountry || "--",
        ["Secondary City*"]: i.secondaryCity || "--",
        ["Secondary Postcode*"]: i.secondaryPostcode || "--",
        ["Secondary Contact Description"]:
          i.secondaryContactDescription || "--",

        ["Invoicing Method*"]: i.invoicingMethod?.invoicingMethod || "--",
        ["Payment Method*"]: i.paymentMethod?.paymentMethod || "--",
        ["Services"]: getServices(i.serviceNameId),

        ["Grand Total"]: i.grandTotal || "--",
        ["Monthly Override"]: i.monthlyOverride || "--",

        ["UTR Applied ?*"]: i.isUTRApplied || "--",
        ["UTR Applied Date*"]: i.UTRAppliedDate
          ? formatDate(i.UTRAppliedDate)
          : "--",

        ["UTR Status*"]: i.UTRStatus || "--",
        ["UTR Number*"]: i.UTRNumber || "--",
        ["UTR Letter Location*"]: i.letterLocationUTR || "--",

        ["Personal Code Applied ?*"]: i.isPersonalCodeApplied || "--",
        ["Personal Code Applied Date*"]: i.personalCodeAppliedDate
          ? formatDate(i.personalCodeAppliedDate)
          : "--",

        ["Personal Code Status*"]: i.personalCodeStatus || "--",
        ["Personal Code Number*"]: i.personalCode || "--",
        ["Personal Code Letter Location*"]:
          i.letterLocationPersonalCode || "--",

        ["CAC Status"]: i.CACStatus || "--",
        ["CAC Number*"]: i.CACNumber || "--",
        ["CAC Letter Location*"]: i.letterLocationCAC || "--",

        ["PAYE Status"]: i.PAYEStatus || "--",
        ["PAYE Number*"]: i.PAYENumber || "--",
        ["PAYE Letter Location*"]: i.letterLocationPAYE || "--",

        ["VAT Status"]: i.VATStatus || "--",
        ["VAT Number*"]: i.VATNumber || "--",
        ["VAT Letter Location*"]: i.letterLocationVAT || "--",
        ["VAT First Period End"]: i.VATFirstPeriod
          ? formatDate(i.VATFirstPeriod)
          : "--",
        ["VAT Frequency"]: i.VATFrequency || "--",
        ["VAT Current Period End"]: i.VATCurrentPeriodEnd
          ? formatDate(i.VATCurrentPeriodEnd)
          : "--",
        ["VAT Current Period Due Date"]: i.VATCurrentPeriodDueDate
          ? formatDate(i.VATCurrentPeriodDueDate)
          : "--",

        ["Officer ID Status"]:
          i.officerIdStatus && i.officerIdStatus === "yes"
            ? "Listed on Company House"
            : "--",
        ["Officer ID"]: i.officerId ? i.officerId : "--",

        ["Account & Tax Current Period End"]: i.accountsAndTaxCurrentYearDueDate
          ? formatDate(i.accountsAndTaxCurrentYearDueDate)
          : "--",
        ["Account & Tax Next Due Date"]: i.accountsAndTaxNextYearDueDate
          ? formatDate(i.accountsAndTaxNextYearDueDate)
          : "--",

        ["CIS Current Period End*"]: i.CISDate ? formatDate(i.CISDate) : "--",
        ["CIS Current Period Due Date"]: i.CISDueDate
          ? formatDate(i.CISDueDate)
          : "--",

        // ["Payroll Frequency"]: i.payrollFrequency,
        // ["Payroll First Weekly Date"]: formatDate(i.payrollFirstWeeklyDate),
        // ["Payroll Second Weekly Date"]: formatDate(i.payrollSecondWeeklyDate),

        // ["Payroll First Fortnightly Date"]: formatDate(i.payrollFirstFortNightlyDate),
        // ["Payroll Second Fortnightly Date"]: formatDate(i.payrollSecondFortNightlyDate),

        // ["Payroll First Fourweekly Date"]: formatDate(i.payrollFirstFourWeeklyDate),
        // ["Payroll Second Fourweekly Date"]: formatDate(i.payrollSecondFourWeeklyDate),

        // ["Payroll First Monthly Date"]: formatDate(i.payrollFirstMonthlyDate),
        // ["Payroll Second Monthly Date"]: formatDate(i.payrollSecondMonthlyDate),

        ["Bookkeeping First Period End"]: i.bookkeepingFirstPeriodEnd
          ? formatDate(i.bookkeepingFirstPeriodEnd)
          : "--",
        ["Bookkeeping Frequency"]: i.bookkeepingFrequency,
        ["Bookkeeping Current Period End"]: i.bookkeepingCurrentPeriodEnd
          ? formatDate(i.bookkeepingCurrentPeriodEnd)
          : "--",
        ["Bookkeeping Current Period Due Date"]:
          i.bookkeepingCurrentPeriodDueDate
            ? formatDate(i.bookkeepingCurrentPeriodDueDate)
            : "--",

        ["Management Account First Period End"]:
          i.managementAccountFirstPeriodEnd
            ? formatDate(i.managementAccountFirstPeriodEnd)
            : "--",
        ["Management Account Frequency"]: i.managementAccountFrequency,
        ["Management Account Current Period End"]:
          i.managementAccountCurrentPeriodEndDate
            ? formatDate(i.managementAccountCurrentPeriodEndDate)
            : "--",
        ["Management Account Current Period Due Date"]:
          i.managementAccountCurrentPeriodDueDate
            ? formatDate(i.managementAccountCurrentPeriodDueDate)
            : "--",

        ["CS current Year Due Date"]: i.CScurrentYearDueDate
          ? formatDate(i.CScurrentYearDueDate)
          : "--",
        ["Current CS Year Due Date"]: i.currentCSYearDueDate
          ? formatDate(i.currentCSYearDueDate)
          : "--",

        ["Current KYC Due Date*"]: i.currentKYCDueDate
          ? formatDate(i.currentKYCDueDate)
          : "--",
        ["KYC Frequency*"]: i.KYCFrequency
          ? `${i.KYCFrequency} ${i.KYCFrequency != 1 ? "years" : "year"}`
          : "--",
        ["Next KYC Due Date"]: i.nextKYCDueDate
          ? formatDate(i.nextKYCDueDate)
          : "--",

        ["Client Under Practice*"]: i.clientUnderPractice?.practiceName || "--",

        ["Client Manager*"]: i.clientManager?.id
          ? `${i.clientManager?.name} ${i.clientManager?.lastName}`
          : "--",
        ["Production Manager*"]: i.productionManager?.id
          ? `${i.productionManager?.name} ${i.productionManager?.lastName}`
          : "--",
        ["Assistant*"]: i.assistant?.id
          ? `${i.assistant?.name} ${i.assistant?.lastName}`
          : "--",
        ["Administrator*"]: i.administrator?.id
          ? `${i.administrator?.name} ${i.administrator?.lastName}`
          : "--",
        ["Payroll Manager"]: i.payrollManager?.id
          ? `${i.payrollManager?.name} ${i.payrollManager?.lastName}`
          : "--",
        ["CIS Manager"]: i.CISManager?.id
          ? `${i.CISManager?.name} ${i.CISManager?.lastName}`
          : "--",

        ["Created Date"]: moment(i.createdAt).format("DD-MM-YYYY | hh:mm A"),
      }))
    }

    let exportdata = []

    if (selectForExport.length) {
      exportdata = getExportingData(
        data.filter(d => selectForExport.some(s => s == d.id))
      )
    } else exportdata = getExportingData(data)

    // Create a worksheet from the Clients Data
    const ws = XLSX.utils.json_to_sheet(exportdata)
    // Create a new workbook and append the worksheet
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, "Clients Data")

    // Write the workbook to a file
    XLSX.writeFile(
      wb,
      `Clients-(${moment().format("DD-MM-YYYY_HH-mm-ss")}).xlsx`
    )
    setSelectForExport([])
  }

  // const handleImportClients = async (e) => {
  //   e.preventDefault()
  //   setLoading(true)
  //   try {
  //     const formData = new FormData()
  //     formData.append("clientData", clientFile)

  //     const { data } = await axiosbaseurl.post(`/client/upload/clients`, formData);
  //     if (data.success) {
  //       swal("", "All Clients Added Successfully.", "success")
  //         .then(() => {
  //           window.location.reload()
  //         })
  //     }
  //   } catch (error) {
  //     console.log(error)
  //     swal("", error.response.data.message || "Something went Wrong", "error")
  //   } finally {
  //     setLoading(false)
  //   }
  // }

  const filterContent = (
    <div>
      <div className="px-4 pt-2" style={{ width: "900px" }}>
        <ClientFilter
          emp_options={emp_options}
          practice_options={practice_options}
          status_options={status_options}
          all_clients={all_client_data}
          settable_data={settable_data}
          setVisible={setVisible}
          //           table_data, settable_data
          // all_client_data, setall_client_data
        />
      </div>
    </div>
  )

  const handleAllCheckUncheck = e => {
    // e.stopPropagation()
    // e.bubbles()

    if (e.target.checked) {
      setSelectForExport(data.map(client => client.id))
    } else {
      setSelectForExport([])
    }
  }

  return (
    <>
      {loading && <Loader />}
      <div className="page-content mb-5">
        <Container fluid>
          <Breadcrumb title={"Dashboard"} breadcrumbItem={"Clients"} />
          <Row>
            <Card className="px-0 mx-0">
              <CardBody>
                <PermittedComponent isAccess={checkAccess(module_id, "view")}>
                  <CommonTable
                    columns={columns}
                    data={data}
                    heading={
                      <>
                        Clients
                        {selectForExport.length ? (
                          <button
                            onClick={() => {
                              setShowEmails(true)
                            }}
                            title="Email Templates"
                            className="btn btn-primary mx-4"
                          >
                            <i className="fas fa-envelope me-2"></i> Send Email
                            ( {selectForExport.length} Clients )
                          </button>
                        ) : null}
                      </>
                    }
                    customSearchBar={
                      <div className="search-box me-xxl-2 my-xxl-0 d-inline-block w-100">
                        <div className="position-relative">
                          <label
                            htmlFor="search-bar-0"
                            className="search-label"
                          >
                            <span id="search-bar-0-label" className="sr-only">
                              Search this table
                            </span>
                            <input
                              onChange={e => setSearchValue(e.target.value)}
                              id="search-bar-0"
                              type="text"
                              className="form-control"
                              placeholder="Search ..."
                              style={{ borderRadius: "0.25rem" }}
                              value={searchValue}
                            />
                          </label>
                          <i className="bx bx-search-alt search-icon"></i>
                        </div>
                      </div>
                    }
                    headerHtml={
                      <>
                        <input
                          type="checkbox"
                          onChange={handleAllCheckUncheck}
                          checked={
                            data.length &&
                            selectForExport.length === data.length
                          }
                        />
                      </>
                    }
                  >
                    <div>
                      {isEmailExportAllowed && (
                        <button
                          className="btn btn-success bg-green ms-3"
                          onClick={handleExportToExcel}
                        >
                          <i className="fas fa-download me-2"></i>
                          Export
                        </button>
                      )}

                      <Popover
                        placement="bottomLeft"
                        content={filterContent}
                        title="Filter Clients"
                        trigger="click"
                        visible={visible}
                        onVisibleChange={visible => setVisible(visible)}
                      >
                        <button className="btn btn-outline-primary ms-3">
                          <i className="fas fa-filter me-2"></i> Filter
                        </button>
                      </Popover>

                      {checkAccess(module_id, "add") && (
                        <>
                          <Link
                            to={`${app_url}add-client`}
                            className="btn btn-primary bg-blue ms-3"
                          >
                            <i className="fas fa-plus me-2"></i>
                            Add Client
                          </Link>

                          {/* <button
                                className="btn btn-primary ms-3"
                                onClick={() => setShow2(!show2)}
                              >
                                <i className="fas fa-download me-2"></i>
                                Import
                              </button> */}
                        </>
                      )}

                      {checkAccess(33, "view") && (
                        <button
                          onClick={() => navigate("/client/emails")}
                          className="btn btn-secondary bg-info ms-3"
                        >
                          <i className="fas fa-envelope me-2"></i>
                          Mail Manager ({mailCount})
                        </button>
                      )}

                      <button
                        onClick={() => navigate(-1)}
                        className="btn btn-secondary bg-dark ms-3"
                      >
                        <i className="fas fa-arrow-left me-3"></i>
                        Back
                      </button>
                    </div>
                  </CommonTable>
                </PermittedComponent>
              </CardBody>
            </Card>
          </Row>
        </Container>
      </div>

      {/* email files popup */}
      <ClientEmailFilesModal
        show={showEmailFiles}
        setShow={setShowEmailFiles}
        client={emailFilesClient}
      />

      {/* email templates popup */}
      <ClientEmailTemplates
        show={showEmails}
        setShow={setShowEmails}
        client={clientData}
        setClientData={setClientData}
        clientIds={selectForExport}
        setSelectForExport={setSelectForExport}
      />

      {/* Documents popup */}
      <Modal
        size="lg"
        isOpen={show}
        toggle={() => setShow(!show)}
        centered={true}
      >
        <div className="modal-content">
          <ModalBody className="px-3">
            <div className="d-flex justify-content-between">
              <h5>Documents By {documents?.clientName}</h5>
              <button
                type="button"
                className="btn-close "
                onClick={() => setShow(!show)}
              ></button>
            </div>

            <table className="table mt-4">
              <thead className="table-primary">
                <tr>
                  <th>ID</th>
                  <th>Date</th>
                  <th>Document Name</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {documents?.data?.map((item, i) => (
                  <tr key={i}>
                    <td> {i + 1}</td>
                    <td> {moment(item.createdAt).format("DD-MM-YYYY")}</td>
                    <td> {item.documentMaster.documentName}</td>
                    <td>
                      <a
                        href={`${process.env.REACT_APP_IMAGE_PATH}/${item.uploadedDocument}`}
                        target="_blank"
                        rel="noreferrer"
                        className="btn btn-secondary btn-sm me-2"
                      >
                        <i className="fas fa-download me-2"></i> View
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </ModalBody>
        </div>
      </Modal>

      {/* <Modal
        size="md"
        isOpen={show2}
        toggle={() => setShow2(!show2)}
        centered={true}
      >
        <div className="modal-content">
          <ModalBody className="px-3">
            <div>
              <form onSubmit={handleImportClients}>
                <div>
                  <div className="mb-4">
                    <label htmlFor="">Upload excel file *</label>
                    <input type="file" accept=".xlsx, .xls" required
                      className="form-control input-field"
                      onChange={(e) => setClientFile(e.target.files[0])} />
                  </div>

                  <LoadingButton loading={loading} />
                </div>
              </form>
            </div>
          </ModalBody>
        </div>
      </Modal> */}
    </>
  )
}

export default AllClients
